import React from "react";
import AddProduct from "../../components/AddProduct/AddProduct";
import ProductList from "../../components/ProductList/ProductList";

const Product = () => {
  return (
    <div className="container mx-auto">
      <AddProduct></AddProduct>
      <ProductList></ProductList>
    </div>
  );
};

export default Product;
